import ApplicationSerializer from 'frontend-payments/serializers/application';

export default class TransactionSerializer extends ApplicationSerializer {
  primaryKey = 'transaction_number';
}
